//
//
//
//

import AppLegacyFrame from '~/components/shared/AppLegacyFrame'

export default {
  components: {
    AppLegacyFrame
  },
  computed: {
    legacyUrl() {
      if (this.$route.query.registrationId !== 'false')
        return `/Championships/ChampionshipRegistration/Details/${this.$route.query.registrationId}`
      return `/Championships/Championship/Details/${this.$route.query.championshipId}/ChampionshipRegistration/Edit/0`
    }
  }
}
